// Copyright (c) StrangeBee 2024

import {
    Route as OrganisationsDetailsRoute,
    RouteUser as OrganisationsUserDetailsRoute,
} from './Organisations/Details';
import { Route as OrganisationsListRoute } from './Organisations/List';

import { Route as PlatformManagementRoute } from './PlatformManagement/Details/';

import { Route as EntitiesRoute } from './Entities/Details/';

import { Route as GlobalUsersListRoute } from './GlobalUsers/List/';

export const Routes = [
    OrganisationsListRoute,
    OrganisationsDetailsRoute,
    OrganisationsUserDetailsRoute,

    GlobalUsersListRoute,

    EntitiesRoute,

    PlatformManagementRoute,
];
